module.exports = __webpack_public_path__ + "img/f3-4.98770313.png";